export const dimensions = {
  'max-screen-width': 1300,
  'max-screen-width-without-padding': 1236,
  // $smallish-screen: 550px;
  // $medium-screen: 768px;
  // $large-screen: 992px;
  // $huge-screen: 1200px;
};
